import {
  defineNuxtPlugin,
  useRoute,
  useRouter,
  useRuntimeConfig,
} from '#imports';
import { useRootService } from '@kaokei/use-vue-service';
import { init as initHttpService } from '@core/api/http';
import { RouterService } from '@core/services/router.service';
import { UserService } from '@core/services/user.service';
import { ZoneService } from '@core/services/zone.service';
import { initAnalysisSdk } from '@core/utils/analysisSdk';

export default defineNuxtPlugin((nuxtApp) => {
  // 初始化http实例
  initHttpService();
  // 初始化埋点sdk
  initAnalysisSdk();

  const route = useRoute();
  const router = useRouter();

  const routerService = useRootService(RouterService);
  routerService.setRouter(router);

  const userService = useRootService(UserService);
  const zoneService = useRootService(ZoneService);
  const config = useRuntimeConfig();
  zoneService.initZone(config.app.baseURL.slice(1));
  // 有些特殊页面不需要加载用户信息
  if (!route.meta?.ignoreUser) {
    // 页面加载时，先尝试加载本地数据，同时请求服务器数据
    // 因为当前用户可能已经登录，但是刷新了页面，此时用户实际已经设置了cookie
    userService.initUserWhenPageLoaded(route.query);
  }
});
